import { useMemo } from 'react'
import _ from 'lodash'
import useAxios from 'hooks/useAxios'

// Contract: role string travels under extra.role.
// Distinct from extra.attribute used by customer.attribute / ticket.attribute
// custom-attribute filters — keeps the wire format unambiguous.
//
// Wire format: BE returns a flat list with each role as an entry whose
// key === 'collaborator.role' alongside 'customer.attribute' and
// 'ticket.attribute' entries. We filter to the role rows.
/** @returns {Array|null} */
export default function useCollaboratorRoleOptions() {
  // @ts-ignore
  const { data } = useAxios({
    url: 'reports/preload-advanced-filters/',
  })

  // useMemo keeps the array reference stable across renders when `data` is
  // unchanged — downstream useMemo deps in useFilterOptions stay valid.
  return useMemo(() => {
    if (!data) {
      return null
    }
    return data
      .filter((entry) => entry.key === 'collaborator.role')
      .map((entry) => ({
        field: 'collaborator',
        label: _.upperFirst(_.toLower(entry.label.replace(/_/g, ' '))),
        icon: 'far fa-user-tag',
        comparison: 'is',
        extra: {
          role: entry.field,
        },
      }))
  }, [data])
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useCollaboratorRoleOptions/index.js